// GENERATED by scripts/generate-deploy-components.mjs — DO NOT EDIT.
// Source of truth: deploy/components.yaml
// Regenerate: bun run generate:deploy-components
//
// A hand-edited copy here would be a second inventory drifting from the registry,
// which is precisely what the registry exists to prevent.

export type DeployCheckMode = 'git-pin' | 'release-pin' | 'live-probe' | 'auto';

export interface DeployComponentHold {
  reason: string;
  until: string;
}

export interface DeployComponent {
  name: string;
  description: string;
  check: DeployCheckMode;
  pinStyle: string;
  promotion: string;
  environment: string;
  imageRepo: string;
  manifestPath: string | null;
  sourcePaths: string[];
  alsoPinnedIn: string[];
  buildWorkflow: string | null;
  verify: string;
  /** Whether "is it actually running?" is answerable for this component. */
  hasWorkloadProbe: boolean;
  holds: DeployComponentHold[];
}

export const DEPLOY_COMPONENTS: readonly DeployComponent[] = [
  {
    name: 'ci-conductor',
    description: 'In-cluster CI runner provisioner; provisions every eph-* VM.',
    check: 'git-pin',
    pinStyle: 'digest',
    promotion: 'argocd:dev',
    environment: 'production',
    imageRepo: 'gitea.mahoosuc.ai/mahoosuc-solutions/ci-conductor',
    manifestPath: 'deploy/ci-conductor/k8s/cronjob.yaml',
    sourcePaths: ['ops/ci-conductor', 'deploy/ci-conductor/Dockerfile'],
    alsoPinnedIn: [],
    buildWorkflow: '.gitea/workflows/publish-ci-conductor-image.yml',
    verify: "grep -L 'RAM-backed temp unavailable' the newest Test Suite/test log",
    hasWorkloadProbe: true,
    holds: [],
  },
  {
    name: 'maestro-app',
    description: 'The Maestro orchestrator itself (maestro namespace).',
    check: 'release-pin',
    pinStyle: 'tag',
    promotion: 'argocd:main',
    environment: 'production',
    imageRepo: 'gitea.mahoosuc.ai/mahoosuc-solutions/masetro',
    manifestPath: 'k8s/deployment.yaml',
    sourcePaths: [],
    alsoPinnedIn: [],
    buildWorkflow: '.gitea/workflows/publish-artifacts.yml',
    verify: 'bun scripts/deploy-verify.ts',
    hasWorkloadProbe: true,
    holds: [],
  },
  {
    name: 'maestro-secure-runner',
    description: 'Sandboxed execution broker/controller (maestro-execution ns).',
    check: 'release-pin',
    pinStyle: 'digest',
    promotion: 'argocd:main',
    environment: 'production',
    imageRepo: 'gitea.mahoosuc.ai/mahoosuc-solutions/masetro',
    manifestPath: 'k8s/secure-runner/controller.yaml',
    sourcePaths: [],
    alsoPinnedIn: [],
    buildWorkflow: '.gitea/workflows/publish-artifacts.yml',
    verify: 'bash scripts/secure-runner/preflight.sh',
    hasWorkloadProbe: false,
    holds: [
      {
        reason:
          'Deliberately pinned to the registry-verified v0.17.0 baseline digest and NOT YET APPLIED to any cluster; k8s/secure-runner/README.md states production authorization stays blocked until the exact source/image/GitOps tuple is verified. Remove this hold when the release image-pin PR lands.',
        until: 'applied',
      },
    ],
  },
  {
    name: 'customer-self-host',
    description: 'Customer Docker Compose stack shipped by deploy/install.sh.',
    check: 'release-pin',
    pinStyle: 'tag',
    promotion: 'manual',
    environment: 'customer',
    imageRepo: 'gitea.mahoosuc.ai/mahoosuc-solutions/masetro',
    manifestPath: 'deploy/docker-compose.yml',
    sourcePaths: [],
    alsoPinnedIn: [
      'docker-compose.thin.yml',
      'docker-compose.localhost-federation.yml',
      'scripts/paired-local-enroll.mjs',
    ],
    buildWorkflow: '.gitea/workflows/publish-artifacts.yml',
    verify: 'none',
    hasWorkloadProbe: false,
    holds: [],
  },
  {
    name: 'hermes-admin',
    description: 'Marvin control plane (agentmarvin.mahoosuc.ai), deployed over SSH.',
    check: 'live-probe',
    pinStyle: 'tag',
    promotion: 'ssh-hitl',
    environment: 'production',
    imageRepo: 'unknown',
    manifestPath: null,
    sourcePaths: [],
    alsoPinnedIn: [],
    buildWorkflow: null,
    verify: 'bun run cli workflow run maestro-hermes-admin-deploy dry_run=true --no-worktree',
    hasWorkloadProbe: false,
    holds: [],
  },
  {
    name: 'local-server',
    description:
      'Workstation systemd --user instance; federation SUBORDINATE holding the same MAESTRO_FEDERATION_KEY as the cloud authority.',
    check: 'live-probe',
    pinStyle: 'none',
    promotion: 'manual',
    environment: 'local',
    imageRepo: 'none',
    manifestPath: 'scripts/systemd/maestro-server.service',
    sourcePaths: [],
    alsoPinnedIn: [],
    buildWorkflow: null,
    verify: 'systemctl --user status maestro-server',
    hasWorkloadProbe: false,
    holds: [],
  },
  {
    name: 'docs-site',
    description: 'packages/docs-web published to GitHub Pages.',
    check: 'auto',
    pinStyle: 'none',
    promotion: 'auto:main',
    environment: 'production',
    imageRepo: 'none',
    manifestPath: null,
    sourcePaths: [],
    alsoPinnedIn: [],
    buildWorkflow: '.github/workflows/deploy-docs.yml',
    verify: 'none',
    hasWorkloadProbe: false,
    holds: [],
  },
  {
    name: 'gitea-builder',
    description: 'Forge host stack (Gitea + act_runner + Caddy + Postgres).',
    check: 'release-pin',
    pinStyle: 'tag',
    promotion: 'manual',
    environment: 'production',
    imageRepo: 'third-party',
    manifestPath: 'deploy/gitea-builder/docker-compose.yml',
    sourcePaths: [],
    alsoPinnedIn: [],
    buildWorkflow: null,
    verify: 'none',
    hasWorkloadProbe: false,
    holds: [
      {
        reason:
          'Pins upstream :latest tags (gitea:latest-rootless, act_runner:latest). Reported, not enforced: pinning third-party images is a separate risk decision, deliberately out of scope for the freshness work.',
        until: 'third-party-pinning-decision',
      },
    ],
  },
] as const;
